import Phaser from "phaser";
import type { MonsterConfig } from "@/phaser/core/monsters/monsterCatalog";
import type { Direction } from "@phaser/core/queueItem/queueItem";
import { AudioManager } from "@phaser/core/audio/AudioManager";
import type { SfxKey } from "@phaser/core/audio/audioCatalog";

interface MonsterFailEffectOptions {
  width: number;
  height: number;
}

// 몬스터 실패 시 효과 재생 (죽어서 날아가는 애니메이션 + 효과음)
export function playMonsterFailEffect(
  scene: Phaser.Scene,
  monster: MonsterConfig,
  direction: Direction,
  options: MonsterFailEffectOptions,
) {
  const { width, height } = options;
  const deadKey = `${monster.textureKey}-dead`;

  const startX = direction === "LEFT" ? width * 0.2 : width * 0.8;
  const startY = height;

  const sprite = scene.add.image(startX, startY, deadKey);
  sprite.setOrigin(0.5);
  sprite.setScale(0.72);
  sprite.setDepth(99);

  AudioManager.playSfx(getDeadSfxKey(monster));

  const peakY = height * 0.5;
  const endX =
    direction === "LEFT" ? startX - width * 0.5 : startX + width * 0.5;
  const endY = height / 2;
  const angle = direction === "LEFT" ? -180 : 180;

  scene.tweens.add({
    targets: sprite,
    x: { from: startX, to: endX },
    ease: "Linear",
    duration: 600,
  });

  scene.tweens.add({
    targets: sprite,
    y: { from: startY, to: peakY },
    ease: "Cubic.easeOut",
    duration: 300,
    onComplete: () => {
      scene.tweens.add({
        targets: sprite,
        y: endY,
        ease: "Quad.easeIn",
        duration: 300,
        onComplete: () => sprite.destroy(),
      });
    },
  });

  scene.tweens.add({
    targets: sprite,
    angle,
    ease: "Linear",
    duration: 600,
  });
}

// 몬스터의 서식지에 따라 다른 효과음 재생
function getDeadSfxKey(monster: MonsterConfig): SfxKey {
  switch (monster.habitat) {
    case "SEA":
      return "sfx-sea-dead";
    case "DESERT":
      return "sfx-desert-dead";
    case "FOREST":
      return "sfx-forest-dead";
    case "FACTORY":
      return "sfx-factory-dead";
    default:
      return "sfx-sea-dead";
  }
}
